import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ClosingCostEstimator from "@/pages/ClosingCostEstimator";

export const Route = createFileRoute("/closing-costs/")({
  head: () => seoHead("/closing-costs/"),
  component: ClosingCostEstimator,
});
